import React, { useEffect, useState } from "react";
import { FiCheckCircle } from "react-icons/fi";

const BillingCleanup = () => {
  const [countdown, setCountdown] = useState(5);
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get("session_id");

    // Notify parent window (opener) of payment success
    const notifyParent = () => {
      if (window.opener && sessionId) {
        try {
          window.opener.postMessage(
            { type: "PAYMENT_SUCCESS", sessionId, timestamp: Date.now() },
            window.location.origin
          );
        } catch {}
      }
    };

    notifyParent();
    const notifyInterval = setInterval(notifyParent, 500);
    setTimeout(() => clearInterval(notifyInterval), 3000);

    // Countdown → auto-close
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          setTimeout(() => {
            try {
              window.close();
              setTimeout(() => setShowFallback(true), 1000);
            } catch {
              setShowFallback(true);
            }
          }, 500);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(timer);
      clearInterval(notifyInterval);
    };
  }, []);

  const handleClose = () => {
    try {
      window.close();
      setTimeout(() => setShowFallback(true), 500);
    } catch {
      setShowFallback(true);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
        fontFamily: "'Inter', sans-serif",
        color: "#111",
      }}
    >
      <div style={{ textAlign: "center", maxWidth: "400px", padding: "0 20px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            marginBottom: "8px",
          }}
        >
          <FiCheckCircle size={28} />
          <h1
            style={{
              fontSize: "24px",
              fontWeight: 800,
              letterSpacing: "-0.02em",
              margin: 0,
            }}
          >
            Payment successful
          </h1>
        </div>

        <p style={{ color: "#888", fontSize: "15px", marginBottom: "32px" }}>
          Your credits have been added to your account.
        </p>

        {!showFallback ? (
          <>
            <button
              onClick={handleClose}
              style={{
                padding: "10px 24px",
                fontSize: "14px",
                fontWeight: 600,
                color: "#fff",
                backgroundColor: "#000",
                border: "none",
                borderRadius: "10px",
                cursor: "pointer",
                marginBottom: "16px",
              }}
            >
              Close tab
            </button>
            <p style={{ color: "#bbb", fontSize: "13px" }}>
              Auto-closing in {countdown}s
            </p>
          </>
        ) : (
          <p style={{ color: "#888", fontSize: "14px" }}>
            Please close this tab manually and return to your app.
          </p>
        )}
      </div>
    </div>
  );
};

export default BillingCleanup;
